module.exports = __webpack_public_path__ + "img/metamask-copy-address.48c116cd.png";